module.exports = __webpack_public_path__ + "img/saintbrand-features-grid.9c607c76.jpg";